import React from 'react'
import ClassesIndicator from '../../../../../Components/ClassesIndicator/ClassesIndicator'

const ClassColorAndDetail = () => {

    return (
        <>
            <ClassesIndicator text="md:text-2xs   xl:text-xs" />
            <p className='w-full text-xs text-[#707070]'>Hello, Welcome to the Vehicle Mechanics Course !! My name is Schen chen (Teacher name ) and I'll do my best to help you along your journey. To improve your experience, I'll suggest ...</p>
        </>
    )
}

export default ClassColorAndDetail